import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import SettingSwitch from "@limitless/modern/inputs/setting-switch/SettingSwitch";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useManagerProfileContext } from "../../../../../manager/hooks";
import { useAppConfig } from "@limitless/common/hooks";
import { createSuggestions } from "../../../..";
const AppSettings = ({
  timeZoneDisabled,
  items
}) => {
  const {
    updateManagerTimeZone,
    managerProfile,
    updateBooleanProperty
  } = useManagerProfileContext();
  const {
    config: {
      timeZones
    }
  } = useAppConfig();
  const getAppSettingsItems = React.useMemo(() => {
    return items === null || items === void 0 ? void 0 : items.map(item => ({
      ...item,
      checked: managerProfile[item.profileKey],
      handleSwitchChange: () => updateBooleanProperty(item.profileKey, !managerProfile[item.profileKey])
    }));
  }, [managerProfile]);
  const timeZoneList = createSuggestions(timeZones, {
    labelDataKey: "timeZone",
    valueDataKey: "timeZoneDescription"
  });
  const selectedTimeZone = timeZoneList.find(tz => tz.value === managerProfile.value);
  return /*#__PURE__*/React.createElement(Grid, {
    mt: theme => theme.spacing(3)
  }, /*#__PURE__*/React.createElement(SettingSwitch, {
    items: getAppSettingsItems,
    showAnimation: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5.8
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    label: "Time Zone",
    id: "appSettingsTimeZoneList",
    value: selectedTimeZone || timeZoneList[0],
    options: timeZoneList,
    onChange: (e, selectedValue) => updateManagerTimeZone(selectedValue),
    disabled: timeZoneDisabled
  }), !timeZoneDisabled && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: {
      color: theme => theme.palette.grey[3]
    }
  }, "All date/times will be formatted to this timezone"))));
};
export default AppSettings;
AppSettings.propTypes = {
  timeZoneDisabled: PropTypes.bool,
  items: PropTypes.array
};